import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id B8358F0C-19A7-4E55-AF98-F4FEFA983148
 * name door-sliding-open
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-sliding-open.svg
 * tags
 * - Home Automation 
 */
export const DoorSlidingOpenIcon = createSvgIcon(<><path d="M6 11V13H4V11H6M22 5H17V19H22V5M7 5H2L2 19H7V5M22 3C23.11 3 24 3.89 24 5V21H0V5C0 3.89 .894 3 2 3H9V19H15V3H22M20 11H18V13H20V11Z" /></>, 'DoorSlidingOpenIcon');
export default DoorSlidingOpenIcon